import { IReturn as ApplicantType } from "../api/resources/ApplicantType";

export const actionTypes = {
    CLEAR: 'wizard.transfer.clear',
    START: 'wizard.transfer.start',
    ACCEPT_DISCLAIMER: 'wizard.transfer.accept.disclaimer',
    SELECT_TYPE: 'wizard.transfer.set.type',
    SET_DATA: 'wizard.transfer.set.data',
    CONFIRMED: 'wizard.transfer.confirmed',
};

export const actions = {
    clear: () => ({
        type: actionTypes.CLEAR
    }),

    start: () => ({
        type: actionTypes.START
    }),

    acceptDisclaimer: () => ({
        type: actionTypes.ACCEPT_DISCLAIMER
    }),

    selectType: (applicantType: number, location?: number, notes?: string, vendor?: number) => ({
        type: actionTypes.SELECT_TYPE,
        applicantType,
        location,
        notes,
        vendor,
    }),

    setData: (
        citizenship: string,
        firstName: string,
        middleName: string, 
        lastName: string, 
        dob: Date,
        ssn4: string,
        phone: string,
        email: string,
        gender: string,
        race: string,
        height: string,
        weight: string,
        eye: string,
        hair: string,
        pob: string,
        reason: string,
        residence: string
    ) => ({
        type: actionTypes.SET_DATA,
        citizenship,
        firstName, 
        middleName,
        lastName, 
        dob,
        ssn4,
        phone,
        email,
        gender,
        race,
        height,
        weight,
        eye,
        hair,
        pob,
        reason,
        residence
    }),

    confirm: () => ({
        type: actionTypes.CONFIRMED
    }),
};


